import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Table from "react-bootstrap/Table";
import { Authorization } from "../../../Context/Authorization";
import Preloader from "../../../shared/PreLoaders";

const RangeMembersPage = () => {
  const { rangeId } = useParams();
  const [vfcList, setVfcList] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const Api = process.env.REACT_APP_API;
  const [summary, setSummary] = useState({});
  const LOCAL_KEY = `rangeMemberDataCache_${rangeId}`;

  const saveToLocalCache = (data, summary) => {
    const cache = {
      data,
      summary,
      timestamp: new Date().toISOString(),
    };
    localStorage.setItem(LOCAL_KEY, JSON.stringify(cache));
  };

  const loadFromLocalCache = () => {
    const raw = localStorage.getItem(LOCAL_KEY);
    return raw ? JSON.parse(raw) : null;
  };

  const fetchData = async () => {
    const config = Authorization();
    try {
      const res = await axios.get(
        `${Api}/api/drill/by-range/${rangeId}`,
        config
      );
      setVfcList(res.data.data);
      saveToLocalCache(res.data.data, res.data.summary);
      setSummary(res.data.summary);
    } catch (error) {
      console.error("Failed to load VFCs", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    const cached = loadFromLocalCache();
    if (cached?.data) {
      setVfcList(cached.data);
      setSummary(cached.summary || {});
      setLoading(false);
    } else {
      fetchData();
    }
  }, [rangeId]);
  const formatDateTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
  };
  if (loading) return <Preloader loading={true} />;
  return (
    <div>
      <div className="page-header">
        <h3 className="page-title">VFCs in Selected Range</h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li
              className="breadcrumb-item"
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => navigate(-1)}
            >
              ← Back
            </li>
            <li
              className="breadcrumb-item active"
              style={{
                color: "red",
                cursor: "pointer",
              }}
              onClick={() => navigate("/dashboard")}
            >
              🏠 Home
            </li>
            <li
              className="breadcrumb-item"
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => navigate(+1)}
            >
              → Previous
            </li>
          </ol>
        </nav>
      </div>
      <div className="d-flex justify-content-between align-items-center mb-3 px-2">
        <button
          className="btn btn-sm btn-outline-secondary"
          onClick={() => {
            localStorage.removeItem(LOCAL_KEY);
            setLoading(true);
            fetchData();
          }}
        >
          🔄 Refresh Now
        </button>

        <div className="text-muted small">
          Last Refreshed:
          {loadFromLocalCache()?.timestamp
            ? formatDateTime(loadFromLocalCache().timestamp)
            : "Not Available"}
        </div>
      </div>
      <div className="card bg-gradient-RainforestMist card-img-holder text-white">
        <div className="card-body">
          <img
            src={require("../../../../assets/images/dashboard/circle.png")}
            className="card-img-absolute"
            alt="circle"
          />
          <h4 className="font-weight-normal mb-3">
            {" "}
            {vfcList.length > 0 ? vfcList[0].rangeName : "Loading..."} Range
          </h4>
          <h1>
            {(summary?.totalDivisionMembers || 0).toLocaleString("en-IN")} -
            Member's
          </h1>
        </div>
      </div>
      <div className="mt-3">
        {loading ? (
          <p>Loading...</p>
        ) : (
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>#</th>
                <th>VFC Name</th>
                <th>Division</th>
                <th>Circle</th>
                <th className="text-center">Date of Establishment</th>
                <th className="text-center">Total Members</th>
                <th className="text-center">Male</th>
                <th className="text-center">Female</th>
                <th className="text-center">Third Gender</th>
              </tr>
            </thead>
            <tbody>
              {vfcList
                .sort((a, b) => a.vfcName.localeCompare(b.vfcName))
                .map((vfc, index) => (
                  <tr key={vfc._id}>
                    <td>{index + 1}</td>
                    <td
                      style={{
                        color: "blue",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                      onClick={() => navigate(`/drill/members/${vfc.vfcId}`)}
                    >
                      {vfc.vfcName}
                    </td>
                    <td>{vfc.divisionName}</td>
                    <td>{vfc.circleName}</td>
                    <td className="text-center">{vfc.dateOfEstablishment}</td>
                    <td className="text-center">
                      {vfc.totalMembers.toLocaleString("en-IN")}
                    </td>
                    <td className="text-center">
                      {vfc.maleCount.toLocaleString("en-IN")}
                    </td>
                    <td className="text-center">
                      {vfc.femaleCount.toLocaleString("en-IN")}
                    </td>
                    <td className="text-center">
                      {vfc.otherCount.toLocaleString("en-IN")}
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        )}
      </div>
    </div>
  );
};
export default RangeMembersPage;
